import React from "react"
import { ThemeContext } from "./theme"
import { Moon } from "react-feather"
import { css } from "@emotion/core"

const DarkToggle = () => {
  const { colorMode, setColorMode } = React.useContext(ThemeContext)
  var [checked, setChecked] = React.useState(colorMode == "dark")
  checked = (colorMode == "dark")
  if (!colorMode) {
    return null
  }

  return (
    <button
      aria-label="Dark Mode Toggle"
      css={css`
        display: flex;
        float: right;
        position: relative;
        border-radius: 5px;
        width: 50px;
        height: 40px;
        -moz-box-align: center;
        align-items: center;
        -moz-box-pack: center;
        justify-content: center;
        // background: var(--color-primary);
        fill: var(--color-text);
        &:hover {
          svg {
            fill: var(--color-text);
          }
        }
      `}
      onClick={ev => {
        setChecked(!checked) 
        setColorMode(!checked ? "dark" : "light")
      }}
    >
      <Moon
        css={css`
          stroke: var(--color-text);
          overflow: visible !important;
        `}
        size={20}
        strokeWidth={2.5}
      />
    </button>
  )
}

export default DarkToggle
